module.exports = __webpack_public_path__ + "50a4df349ad6c5ddfc6cea2342893c6c.ttf";